import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import entityActions from "../../../entities/actions";
import terminalActions from "../../../terminals/actions";
import InterfaceSelectorConfigField from "../../components/fields/InterfaceSelectorConfigField";
import interfaceActions from "../../../interfaces/actions";

class InterfaceSelectorConfigFieldContainer extends Component {

    componentDidMount() {
        const {
            getEntityList,
            formData,
            getTerminalList,
            getInterfaceList
        } = this.props;

        getEntityList();

        if (formData.entityId && formData.entityId.value){
            getTerminalList({entityId : formData.entityId.value });
            if (formData.terminalId && formData.terminalId.value){
                getInterfaceList({entityId : formData.entityId.value, terminalId : formData.terminalId.value });
            } else {
                getInterfaceList({entityId : formData.entityId.value });
            }
        }
    };

    handleInterfaceSelectorFieldChange = (id, value) => {
        const {
            handleFieldChange,
            formData,
            getTerminalList,
            getInterfaceList
        } = this.props;

        if (id === "entityId"){
            handleFieldChange("terminalId", undefined, () => {
                handleFieldChange("interfaceIds", undefined, () => {
                    getTerminalList({entityId : value });
                    getInterfaceList({entityId : value });
                    handleFieldChange("entityId", value)
                });
            });
        } else if(id === "terminalId") {
            handleFieldChange("interfaceIds", undefined, () => {
                getInterfaceList({entityId : formData.entityId.value, terminalId : value });
                handleFieldChange("terminalId", value)
            });
        } else {
            handleFieldChange("interfaceIds", value)
        }
    };

    render() {
        const {
            entityList,
            fieldConfig,
            formData,
            terminalsList,
            interfaceList
        } = this.props;

        return <InterfaceSelectorConfigField
            formData={formData}
            name={fieldConfig.name}
            entityList={entityList}
            terminalsList={terminalsList}
            interfaceList={interfaceList}
            fieldConfig={fieldConfig}
            handleFieldChange={this.handleInterfaceSelectorFieldChange}
        />;
    }
}

const mapStateToProps = ({ entitiesReducer, terminalsReducer, interfacesReducer }) => {
    return {
        entityList: entitiesReducer.entityList,
        terminalsList: terminalsReducer.terminalList,
        interfaceList: interfacesReducer.interfaceList,
    };
};

const mapDispatchToProps = {
    getEntityList: entityActions.getEntityList,
    getTerminalList: terminalActions.getTerminalList,
    getInterfaceList: interfaceActions.listInterfaces
};

InterfaceSelectorConfigFieldContainer.propTypes = {
    name: PropTypes.string,
    fieldConfig: PropTypes.object,
    handleFieldChange: PropTypes.func,
    formData: PropTypes.object
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InterfaceSelectorConfigFieldContainer);
